import React, { Component } from 'react';
import classnames from 'classnames';
import formatTime from './../utils/formatTime';

import OrderTabQAItem from './OrderTabQAItem';
import QACollapseItem from './QACollapseItem';

import grid from './../styles/grid.styl';
import grading from './../styles/grading.styl';
import baseStyles from 'custom/base.styl';

import { dataContentSectionContent, dataContentSectionStructure, dataContentSectionLanguage, dataContentSectionFormat } from './../constants/dataQACategory';

class OrderTabQA extends Component {
  constructor(props) {
    super(props);

    this.state = {
      titleContent: null,
      titleStructure: null,
      titleLanguage: null,
      titleFormat: null,
      sumTitleContent: 0,
      sumTitleStructure: 0,
      sumTitleLanguage: 0,
      sumTitleFormat: 0,
    };

    this.setGradingValue = this.setGradingValue.bind(this);
    this.setGradingSum = this.setGradingSum.bind(this);
    this.setTitle = this.setTitle.bind(this);
  }

  setGradingSum(title, value) {
    this.setState({
      [title]: value
    });
  }

  setGradingValue(isGradingLow) {
    this.setState({
      isGradingLow
    });
  }

  setTitle(name, value) {
    this.setState({ [name]: value });
  }

  getRatingString() {
    const { order } = this.props;

    const pregraderRating = order.pregrader_assessing_avg;
    let pregraderRatingStr = `${pregraderRating}`;

    if (pregraderRating < 55) {
      // pregraderRatingStr = `${pregraderRating}`;
      pregraderRatingStr = '55';
    }

    if (pregraderRating >= 55 && pregraderRating <= 59) {
      pregraderRatingStr = `${pregraderRating} (F)`;
    }

    if (pregraderRating >= 60 && pregraderRating <= 69) {
      pregraderRatingStr = `${pregraderRating} (D)`;
    }

    if (pregraderRating >= 70 && pregraderRating <= 79) {
      pregraderRatingStr = `${pregraderRating} (C)`;
    }

    if (pregraderRating >= 80 && pregraderRating <= 89) {
      pregraderRatingStr = `${pregraderRating} (B)`;
    }

    if (pregraderRating >= 90 && pregraderRating <= 100) {
      pregraderRatingStr = `${pregraderRating} (A)`;
    }

    return pregraderRatingStr;
  }

  renderFileRow(file, key) {
    return (
      <div className={classnames(grid.space_between, grid.row, baseStyles.space_bottom, grading.upload_file_item)} key={`file-row-${key}`}>
        <div className={classnames(grid.col_4, baseStyles.left)}>
          <a href={file.location} target="_blank" rel="noopener noreferrer"><span>{file.name}</span></a>
        </div>
        <div className={classnames(grid.col_8, baseStyles.right, baseStyles.order_file_date)}>
          {file.owner_role} on {formatTime(file.created_at, 'dt')}
        </div>
      </div>
    )
  }


  render() {
    const { order } = this.props;
    const { titleContent, titleStructure, titleLanguage, titleFormat } = this.state;

    return (
      <div className={grading.grade_box}>

        {order.pregrader_report_form_data &&
          <h3 className={classnames(grading.grade_box_head, grading.grade_sum)}>Your grade: <strong>{this.getRatingString()}</strong></h3>
        }

        {order.grading_comment &&
          <div className={grading.grading_comment}><b>Comment:</b> <br/> {order.grading_comment}</div>
        }

        {order.pregrader_report_form_data &&
          <div>
            <div className={grading.person_info_box}>
              <QACollapseItem title="Content" titleCounters={titleContent}>
                <OrderTabQAItem
                  dateSection={dataContentSectionContent}
                  dataRow={order.pregrader_report_form_data}
                  setTitle={this.setTitle}
                  sumTitle='sumTitleContent'
                  setGradingSum={this.setGradingSum}
                  setGradingValue={this.setGradingValue}
                  title='titleContent'>
                </OrderTabQAItem>
              </QACollapseItem>
            </div>
            <div className={grading.person_info_box}>
              <QACollapseItem title="Structure" titleCounters={titleStructure}>
                <OrderTabQAItem
                  dateSection={dataContentSectionStructure}
                  dataRow={order.pregrader_report_form_data}
                  setTitle={this.setTitle}
                  sumTitle='sumTitleStructure'
                  setGradingSum={this.setGradingSum}
                  setGradingValue={this.setGradingValue}
                  title='titleStructure'>
                </OrderTabQAItem>
              </QACollapseItem>
            </div>
            <div className={grading.person_info_box}>
              <QACollapseItem title="Language" titleCounters={titleLanguage}>
                <OrderTabQAItem
                  dateSection={dataContentSectionLanguage}
                  dataRow={order.pregrader_report_form_data}
                  setTitle={this.setTitle}
                  sumTitle='sumTitleLanguage'
                  setGradingSum={this.setGradingSum}
                  setGradingValue={this.setGradingValue}
                  title='titleLanguage'>
                </OrderTabQAItem>
              </QACollapseItem>
            </div>
            <div className={grading.person_info_box}>
              <QACollapseItem title="Format" titleCounters={titleFormat}>
                <OrderTabQAItem
                  dateSection={dataContentSectionFormat}
                  dataRow={order.pregrader_report_form_data}
                  setTitle={this.setTitle}
                  setGradingSum={this.setGradingSum}
                  sumTitle='sumTitleFormat'
                  title='titleFormat'
                  setGradingValue={this.setGradingValue}>
                </OrderTabQAItem>
              </QACollapseItem>
            </div>
          </div>
        }
      </div>
    );

  }
}

export default OrderTabQA;



// WEBPACK FOOTER //
// ./src/components/OrderTabQA.js